export default {"src":"/_next/static/image/public/images/ic_pl_email.495e35d23a6c1b11a8f07d98fd7cf98a.svg","height":36,"width":36};